import axios from "axios";
import { VendorCataloguesApi } from ".";

export function getVendorCatalogue(id) {
  return axios
    .get(`${VendorCataloguesApi}?vendor=${id}`)
    .then((res) => res.data)
    .catch((err) => console.log(err));
}

export function createVendorCatalogue(data) {
  return axios
    .post(`${VendorCataloguesApi}`, data)
    .then((res) => res.data)
    .catch((err) => null);
}
